import { render, staticRenderFns } from "./DocumentPersonal.vue?vue&type=template&id=5d84d112&"
import script from "./DocumentPersonal.vue?vue&type=script&lang=js&"
export * from "./DocumentPersonal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPersonal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports